export interface Song {
  id: string;
  title: string;
  artist: string;
}

export const initialSongs: Song[] = [
  { id: '1', title: 'ODIO A PRIMERA VISTA', artist: 'ANA SOFI W' },
  { id: '2', title: 'THE FATE OF OPHELIA', artist: 'TAYLOR SWIFT' },
  { id: '3', title: 'SOY YO (PABLO OCHANDO VERSION)', artist: 'MARTA SÁNCHEZ' },
  { id: '4', title: 'CALIFORNIA CHRISTMAS', artist: 'BRYAN ADAMS & FRIENDS' },
  { id: '5', title: 'BEAUTIFUL SPIRITUAL', artist: 'BLUE' },
  { id: '6', title: 'HOT IN DECEMBER', artist: 'KYLIE MINOGUE' },
  { id: '7', title: 'WHAT YOU WANT (TOP POP SONGS OF 2025 MASHUP)', artist: 'MARK 013' },
  { id: '8', title: '¿NARCISISTA O BIPOLAR?', artist: 'ANA SOFI W Y RUSLANA' },
  { id: '9', title: 'CHANGES', artist: 'CHARLIE PUTH' },
  { id: '10', title: 'GIVE ME SOMETHING', artist: 'ONEREPUBLIC' },
  { id: '11', title: 'NO SE ME DA BIEN ODIARTE', artist: 'LEIRE MARTINEZ Y EDURNE' },
  { id: '12', title: 'YOU GET WHAT YOU GIVE (LIVE)', artist: 'KEITH URBAN' },
  { id: '13', title: 'UNITED STATE OF POP 2025 (TALK TO ME)', artist: 'DJ EARWORM' },
  { id: '14', title: 'TAKE GOOD CARE OF MY HEART', artist: 'LE FLEX & ALI ROSE' },
  { id: '15', title: 'PUZZLE', artist: 'CHIARA OLIVER' },
  { id: '16', title: 'THE DEAD DANCE', artist: 'LADY GAGA' },
  { id: '17', title: 'THE BIG GOODBYE', artist: 'AJR' },
  { id: '18', title: 'SOBRAN GILPOLLAS', artist: 'FUNAMBULISTA' },
  { id: '19', title: 'LIAR', artist: 'TERE!' },
  { id: '20', title: 'SO EASY (TO FALL IN LOVE)', artist: 'OLIVIA DEAN' },
  { id: '21', title: '¿TE IMAGINAS?', artist: 'ELA TAUBERT' },
  { id: '22', title: 'SYMMETRY', artist: 'ED SHEERAN' },
  { id: '23', title: 'DON´T LOOK ANY FURTHER', artist: 'SWEET CANDIES' },
  { id: '24', title: 'SO SPECIAL', artist: 'CRAIG DAVID' },
  { id: '25', title: '¿QUÉ ME ESTA PASANDO?', artist: 'EFECTO MARIPOSA Y DESPISTAOS' },
  { id: '26', title: 'LA DAMA DE LARA', artist: 'FRANK QUINTERO' },
  { id: '27', title: 'CAN´T GET ENOUGH', artist: 'BEN TANKARD' },
  { id: '28', title: 'OPALITE', artist: 'TAYLOR SWIFT' },
  { id: '29', title: 'CHARIOT', artist: 'WESTLIFE' },
  { id: '30', title: 'ELISE DANCE', artist: 'PAOLO RUSTICHELLI' },
  { id: '31', title: 'TE PROMETO', artist: 'ELA TAUBERT' },
  { id: '32', title: 'DON´T GIVE UP ON ME', artist: 'JOHNNY GOOD & JAY SEAN' },
  { id: '33', title: 'HELLO LOVE', artist: 'JESSIE WARE' },
  { id: '34', title: 'JUST LIKE THAT', artist: 'JACKIEM JOYNER & BRIAN SIMPSON' },
  { id: '35', title: 'ALL NATURAL', artist: 'RITA ORA' },
  { id: '36', title: 'WHERE IS MY HUSBAND! (REMIX)', artist: 'RAYE, DAVID GUETTA & HYPATON' },
  { id: '37', title: 'CRASHING', artist: 'ED SHEERAN' },
  { id: '38', title: 'SWEAT', artist: 'MELANIE C' },
  { id: '39', title: 'SAVE MY SOUL', artist: 'BASTILLE' },
  { id: '40', title: 'MA QUALE IDEA', artist: 'SERGIO DALMA' },
];
